"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _Chip = _interopRequireDefault(require("../../Chip"));

var MultiValue = function MultiValue(props) {
  // eslint-disable-next-line react/prop-types
  var children = props.children,
      removeProps = props.removeProps,
      selectProps = props.selectProps;
  return _react["default"].createElement("div", {
    className: selectProps.classes.chipWrapper
  }, _react["default"].createElement(_Chip["default"], {
    clickable: true,
    size: "small",
    selected: true,
    label: children,
    onDelete: removeProps.onClick
  }));
};

var _default = MultiValue;
exports["default"] = _default;